import { Shimmer } from '@wartek-id/shimmer'

const SearchResultPreloader = () => {
  return (
    <div className="flex py-4 space-x-4 border-b space-b-2 last-of-type:border-b-0">
      <div className="relative flex-none w-16 h-16">
        <Shimmer
          className="aspect-square rounded-xl"
          style={{ width: '100%', paddingTop: '100%' }}
        />
      </div>
      <div className="w-full">
        <Shimmer
          className="mb-1 rounded-md"
          height={15}
          style={{ width: '100%' }}
        />
        <Shimmer
          className="mb-3 rounded-md"
          height={10}
          style={{ width: '100%' }}
        />
        <Shimmer className="rounded-md" height={10} style={{ width: '50%' }} />
      </div>
    </div>
  )
}

export default SearchResultPreloader
